import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"height":"calc(100vh - 130px)","overflow-y":"hidden"}
}
const _hoisted_2 = { style: {"height":"calc(100vh - 130px)","overflow-y":"auto","margin-left":"0 auto","padding":"auto"} }
const _hoisted_3 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_4 = ["viewBox"]
const _hoisted_5 = ["xlink:href", "height", "width"]
const _hoisted_6 = { style: {"height":"calc(100vh - 130px)","overflow-y":"auto"} }
const _hoisted_7 = {
  key: 0,
  style: {"position":"relative","top":"-12px","left":"20px","right":"auto","z-index":"1","height":"0px"}
}
const _hoisted_8 = { class: "d-flex mr-4" }
const _hoisted_9 = {
  key: 1,
  class: "px-0 pt-2",
  style: {"width":"96vw"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "px-2 pb-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-center"
}
const _hoisted_13 = {
  key: 1,
  class: "d-flex align-center justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_accounting_item_static = _resolveComponent("accounting-item-static")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_HereMap = _resolveComponent("HereMap")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_free_tag = _resolveComponent("free-tag")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_DocumentRouterInExpenseReport = _resolveComponent("DocumentRouterInExpenseReport")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_ExpenseReportAddress = _resolveComponent("ExpenseReportAddress")!
  const _component_select_user = _resolveComponent("select-user")!
  const _component_DocumentWizardDialog = _resolveComponent("DocumentWizardDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "py-2 pl-2 pr-2 pb-1",
    style: _normalizeStyle(_ctx.$vuetify.display.mobile ? 'width: 100vw;' : '')
  }, {
    default: _withCtx(() => [
      (!_ctx.$vuetify.display.mobile)
        ? (_openBlock(), _createBlock(_component_v_window, {
            key: 0,
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.step) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { key: "0" }, {
                default: _withCtx(() => [
                  (_ctx.step === 0)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": "",
                        class: "justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "7",
                            class: "pr-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, { class: "default_card_wm elevation-0 pt-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DocumentMenu, {
                                    MenuOptions: _ctx.documentMenuOptions,
                                    onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                                    onDisplayFile: _cache[1] || (_cache[1] = ($event: any) => (_ctx.leftPart = 'document')),
                                    onDisplayAccountingLine: _cache[2] || (_cache[2] = ($event: any) => (_ctx.leftPart = 'accountingLines')),
                                    onActivity: _cache[3] || (_cache[3] = ($event: any) => (_ctx.leftPart = 'displayActivity')),
                                    onDelete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteDialog = true))
                                  }, null, 8, ["MenuOptions"]),
                                  _createVNode(_component_v_row, { "no-gutters": "" }),
                                  _createVNode(_component_v_window, {
                                    modelValue: _ctx.leftPart,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.leftPart) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_window_item, { value: 'accountingLines' }, {
                                        default: _withCtx(() => [
                                          (_ctx.expenseReport && _ctx.expenseReport.id && _ctx.companyId)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "12" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_accounting_item_static, {
                                                          companyId: _ctx.companyId,
                                                          expenseReportId: _ctx.id,
                                                          mode: "Embedded"
                                                        }, null, 8, ["companyId", "expenseReportId"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }),
                                      (_openBlock(), _createBlock(_component_v_window_item, {
                                        key: _ctx.refreshKey,
                                        value: 'document'
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_2, [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                (_ctx.displayHereMap)
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 0,
                                                      cols: "12",
                                                      class: "justify-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_HereMap, {
                                                          origin: _ctx.hereMapData.origin,
                                                          destination: _ctx.hereMapData.destination,
                                                          vehiculeType: _ctx.hereMapData.vehiculeType
                                                        }, null, 8, ["origin", "destination", "vehiculeType"])
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : (!_ctx.isPDF)
                                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                                        key: 1,
                                                        cols: "12",
                                                        id: "InvoiceDocumentValidation"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_3, [
                                                            (_ctx.selectedDocument)
                                                              ? (_openBlock(), _createElementBlock("svg", {
                                                                  key: 0,
                                                                  id: "svg-document-validation",
                                                                  xmlns: "http://www.w3.org/2000/svg",
                                                                  width: "100%",
                                                                  viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                                                  style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                                                }, [
                                                                  _createElementVNode("image", {
                                                                    id: "svg-image-document-validation",
                                                                    "xlink:href": 
                                                                    _ctx.selectedDocument.signedUrl
                                                                ,
                                                                    x: "0",
                                                                    y: "0",
                                                                    height: `${_ctx.imageHeight}px`,
                                                                    width: `${_ctx.imageWidth}px`
                                                                  }, null, 8, _hoisted_5)
                                                                ], 8, _hoisted_4))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : (_ctx.isPDF)
                                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                                          key: 2,
                                                          cols: "12",
                                                          class: "d-flex justify-center",
                                                          style: {"height":"calc(100vh - 130px)","overflow-y":"auto"},
                                                          id: "InvoiceDocumentValidation"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ossPdf, {
                                                              documentId: _ctx.selectedDocument.id
                                                            }, null, 8, ["documentId"])
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      })),
                                      _createVNode(_component_v_window_item, { value: 'displayActivity' }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_UsersActivitiesHistory, {
                                                expenseReportId: _ctx.expenseReport.id
                                              }, null, 8, ["expenseReportId"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: 5,
                            class: "my-0 pl-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important","height":"calc(100vh - 82px)","overflow-y":"none"},
                                class: "default_card_wm elevation-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "pl-2 pr-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "pt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item, {
                                              border: "",
                                              ripple: false,
                                              class: "mt-2 mb-1 rounded-xl",
                                              id: "StatutNoteDeFrais"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"},
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => _cache[40] || (_cache[40] = [
                                                            _createElementVNode("b", null, "Statut", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.statusText), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item, {
                                              border: "",
                                              ripple: false,
                                              class: "my-1 rounded-xl",
                                              id: "createByNoteDeFrais"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"},
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => _cache[41] || (_cache[41] = [
                                                            _createElementVNode("b", null, "Créé par", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        (_ctx.creator)
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 0,
                                                              cols: "9",
                                                              class: "pl-2"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.creator.firstname) + " " + _toDisplayString(_ctx.creator.lastname), 1)
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item, {
                                              border: "",
                                              ripple: false,
                                              class: "my-1 rounded-xl",
                                              id: "NameNoteDeFrais"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"},
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                                                            _createElementVNode("b", null, "Nom", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_text_field_filled, {
                                                              modelValue: _ctx.expenseReport.name,
                                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.expenseReport.name) = $event)),
                                                              outlined: "",
                                                              "hide-details": "",
                                                              readonly: 
                                                                    _ctx.expenseReport.status ===
                                                                    'VALIDATED'
                                                                ,
                                                              density: "compact"
                                                            }, null, 8, ["modelValue", "readonly"])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item, {
                                              border: "",
                                              ripple: false,
                                              class: "my-1 rounded-xl",
                                              id: "DateNoteDeFrais"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"},
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => _cache[43] || (_cache[43] = [
                                                            _createElementVNode("b", null, "Date", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_oss_date_picker, {
                                                              modelValue: _ctx.expenseReport.date,
                                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.expenseReport.date) = $event)),
                                                              outlined: true,
                                                              "hide-details": true,
                                                              readonly: 
                                                                    !_ctx.commonEnableModification
                                                                ,
                                                              disabled: 
                                                                    _ctx.expenseReport.status ===
                                                                    'VALIDATED'
                                                                ,
                                                              textFieldReadOnly: false
                                                            }, null, 8, ["modelValue", "readonly", "disabled"])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.expenseReport.expenseReport)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: "12"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item, {
                                                  border: "",
                                                  ripple: false,
                                                  class: "my-1 rounded-xl",
                                                  id: "TagNoteDeFrais"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, {
                                                          "no-gutters": "",
                                                          class: "align-center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { class: "pl-2" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_free_tag, {
                                                                  document: 
                                                                    _ctx.expenseReport.expenseReport
                                                                ,
                                                                  company: _ctx.companyId,
                                                                  splitUserPartitions: true,
                                                                  companyTags: _ctx.allCompanyTags
                                                                }, null, 8, ["document", "company", "companyTags"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item, {
                                              border: "",
                                              ripple: false,
                                              class: "my-1 rounded-xl",
                                              id: "CollaborationNoteDeFrais"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"},
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => _cache[44] || (_cache[44] = [
                                                            _createElementVNode("b", null, "Collaborateur", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_text_field_filled, {
                                                              outlined: "",
                                                              readonly: "",
                                                              "hide-details": "",
                                                              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.userDialog = true), ["stop"])),
                                                              value: _ctx.expenseReportUser,
                                                              density: "compact"
                                                            }, null, 8, ["value"])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (
                                            (_ctx.expenseReport.status === 'VALIDATED' &&
                                                _ctx.documents.length) ||
                                            _ctx.expenseReport.status !== 'VALIDATED'
                                        )
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 0,
                                          "no-gutters": "",
                                          class: "pt-2 pb-3",
                                          id: "SupportingDocumentsNoteDeFrais"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { class: "d-flex align-center v-col-auto pr-3" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Justificatif de note de frais (" + _toDisplayString(_ctx.$t("shared.amountOfFiles", _ctx.documents.length || 0, {
                                                    count: _ctx.documents.length || 0,
                                                })) + ") ", 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.expenseReport.status !== 'VALIDATED')
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  class: "d-flex align-center v-col-auto pl-3"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn_add_icon, {
                                                      size: "x-small",
                                                      onClick: _cache[9] || (_cache[9] = ($event: any) => {
                                                    _ctx.activeUploadDocuments = true;
                                                    _ctx.activeTravelExpense = false;
                                                })
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (doc) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: doc.id
                                              }, [
                                                (_ctx.isAccountingUser)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                      _createVNode(_component_v_chip, {
                                                        color: 
                                                            doc.status === 'VALIDATED' &&
                                                            doc.accountableAccount &&
                                                            doc.accountableAccount.name &&
                                                            doc.accountableAccount.name !== '600000'
                                                                ? 'primary'
                                                                : 'grey'
                                                        ,
                                                        style: {"background":"#fff !important"},
                                                        size: "small",
                                                        variant: "outlined"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.$t(
                                                                "document.status." +
                                                                    _ctx.getDocumentStatus(doc),
                                                            )) + " ", 1),
                                                          (
                                                                doc.status === 'VALIDATED' &&
                                                                doc.accountableAccount &&
                                                                doc.accountableAccount.name &&
                                                                doc.accountableAccount.name !==
                                                                    '600000'
                                                            )
                                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                key: 0,
                                                                size: "small",
                                                                right: ""
                                                              }, {
                                                                default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                                  _createTextVNode("$check")
                                                                ])),
                                                                _: 1
                                                              }))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"])
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createVNode(_component_v_list_item, {
                                                  border: "",
                                                  ripple: false,
                                                  class: "mb-5 rounded-xl",
                                                  onClick: ($event: any) => (_ctx.setSelectedDocument(doc))
                                                }, {
                                                  prepend: _withCtx(() => [
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                        _createTextVNode("$oss-file")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              cols: "6",
                                                              class: "pr-1"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_text_field_filled, {
                                                                  modelValue: doc.name,
                                                                  "onUpdate:modelValue": ($event: any) => ((doc.name) = $event),
                                                                  label: "Nom du document",
                                                                  outlined: "",
                                                                  "hide-details": "",
                                                                  class: "mt-1",
                                                                  readonly: 
                                                                        _ctx.expenseReport.status ===
                                                                        'VALIDATED'
                                                                    ,
                                                                  density: "compact"
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, { cols: "5" }, {
                                                              default: _withCtx(() => [
                                                                (doc.accountableAccount)
                                                                  ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                                      key: 0,
                                                                      modelValue: 
                                                                        doc.accountableAccount.name
                                                                    ,
                                                                      "onUpdate:modelValue": [($event: any) => ((
                                                                        doc.accountableAccount.name
                                                                    ) = $event), ($event: any) => (
                                                                        _ctx.categoryChange(doc)
                                                                    )],
                                                                      "item-title": "text",
                                                                      items: _ctx.categories,
                                                                      outlined: "",
                                                                      label: "Catégorie",
                                                                      class: "mt-1",
                                                                      "hide-details": "",
                                                                      readonly: 
                                                                        _ctx.expenseReport.status ===
                                                                        'VALIDATED'
                                                                    ,
                                                                      density: "compact"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "readonly"]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, {
                                                              cols: "1",
                                                              class: "d-flex align-center justify-center"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_btn_icon, {
                                                                  icon: "$oss-edit",
                                                                  onClick: ($event: any) => (_ctx.routeDocument(doc.id)),
                                                                  size: "small"
                                                                }, null, 8, ["onClick"])
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_list_item_subtitle, null, {
                                                      default: _withCtx(() => [
                                                        (
                                                                doc.status ===
                                                                    'ORIGINAL_UPLOADED' ||
                                                                doc.status === 'UPLOADED'
                                                            )
                                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                                              key: 0,
                                                              "no-gutters": "",
                                                              class: "pt-1",
                                                              "align-content": "center",
                                                              justify: "center"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, {
                                                                  cols: "11",
                                                                  class: "text-center py-2"
                                                                }, {
                                                                  default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                                    _createTextVNode(" En cours d'analyse ")
                                                                  ])),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_v_col, {
                                                                  cols: "1",
                                                                  class: "d-flex align-center justify-center"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    (
                                                                        _ctx.expenseReport.status !==
                                                                        'VALIDATED'
                                                                    )
                                                                      ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                                          key: 0,
                                                                          onClick: ($event: any) => (_ctx.deleteDocument(doc.id)),
                                                                          size: "small"
                                                                        }, null, 8, ["onClick"]))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024),
                                                                _createVNode(_component_v_col, { cols: "11" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_progress_linear, {
                                                                      indeterminate: "",
                                                                      rounded: "",
                                                                      height: "6"
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_v_col, { cols: "1" })
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : (_openBlock(), _createBlock(_component_v_row, {
                                                              key: 1,
                                                              "no-gutters": "",
                                                              class: "pt-1"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, { class: "pr-1" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_text_field_filled, {
                                                                      label: "Date",
                                                                      "hide-details": "",
                                                                      readonly: "",
                                                                      "model-value": 
                                                                        _ctx.formatDate(doc.date)
                                                                    
                                                                    }, null, 8, ["model-value"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024),
                                                                _createVNode(_component_v_col, { class: "pr-1" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_text_field_filled, {
                                                                      modelValue: doc.netAmount,
                                                                      "onUpdate:modelValue": ($event: any) => ((doc.netAmount) = $event),
                                                                      label: "HT",
                                                                      readonly: "",
                                                                      "append-inner-icon": "$euro",
                                                                      "hide-details": ""
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024),
                                                                _createVNode(_component_v_col, null, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_text_field_filled, {
                                                                      modelValue: doc.grossAmount,
                                                                      "onUpdate:modelValue": ($event: any) => ((doc.grossAmount) = $event),
                                                                      label: "TTC",
                                                                      readonly: "",
                                                                      "append-inner-icon": "$euro",
                                                                      "hide-details": ""
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024),
                                                                _createVNode(_component_v_col, {
                                                                  cols: "1",
                                                                  class: "d-flex align-center justify-center"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    (
                                                                        _ctx.expenseReport.status !==
                                                                        'VALIDATED'
                                                                    )
                                                                      ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                                          key: 0,
                                                                          onClick: ($event: any) => (_ctx.deleteDocument(doc.id)),
                                                                          size: "small"
                                                                        }, null, 8, ["onClick"]))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (
                                            (_ctx.expenseReport.status === 'VALIDATED' &&
                                                _ctx.travelExpenses.length) ||
                                            _ctx.expenseReport.status !== 'VALIDATED'
                                        )
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 1,
                                          "no-gutters": "",
                                          class: "py-1",
                                          id: "TravellingExpensesNoteDeFrais"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { class: "d-flex align-center v-col-auto pr-3" }, {
                                              default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                _createTextVNode(" Frais de déplacement ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.expenseReport.status !== 'VALIDATED')
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  class: "d-flex align-center v-col-auto pl-3"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn_add_icon, {
                                                      size: "x-small",
                                                      onClick: _cache[10] || (_cache[10] = ($event: any) => {
                                                    _ctx.activeUploadDocuments = false;
                                                    _ctx.activeTravelExpense = true;
                                                    _ctx.currentTravelExpenseDocument = null;
                                                })
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list, { lines: "two" }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.travelExpenses, (doc) => {
                                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                                    border: "",
                                                    ripple: false,
                                                    class: "mb-2 rounded-xl",
                                                    key: doc.id,
                                                    onClick: ($event: any) => (_ctx.setSelectedDocument(doc))
                                                  }, {
                                                    prepend: _withCtx(() => [
                                                      _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                          _createTextVNode("$oss-car")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, { cols: "11" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_text_field_filled, {
                                                                    modelValue: doc.name,
                                                                    "onUpdate:modelValue": ($event: any) => ((doc.name) = $event),
                                                                    label: "Nom du document",
                                                                    outlined: "",
                                                                    "hide-details": "",
                                                                    readonly: 
                                                                        _ctx.expenseReport.status ===
                                                                        'VALIDATED'
                                                                    ,
                                                                    class: "mt-1",
                                                                    density: "compact"
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                cols: "1",
                                                                class: "d-flex align-center justify-center"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_btn_icon, {
                                                                    icon: "$oss-edit",
                                                                    onClick: ($event: any) => (_ctx.openDocument(doc)),
                                                                    size: "small"
                                                                  }, null, 8, ["onClick"])
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_list_item_subtitle, {
                                                        modelValue: _ctx.hereAddressData,
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.hereAddressData) = $event))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_row, {
                                                            "no-gutters": "",
                                                            class: "pt-1"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_col, { class: "pr-1" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_text_field_filled, {
                                                                    label: "Date",
                                                                    outlined: "",
                                                                    readonly: "",
                                                                    "hide-details": "",
                                                                    "model-value": 
                                                                        _ctx.formatDate(doc.date)
                                                                    ,
                                                                    density: "compact"
                                                                  }, null, 8, ["model-value"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, { class: "pr-1" }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_text_field_filled, {
                                                                    modelValue: doc.netAmount,
                                                                    "onUpdate:modelValue": ($event: any) => ((doc.netAmount) = $event),
                                                                    label: "HT",
                                                                    outlined: "",
                                                                    readonly: "",
                                                                    dense: "",
                                                                    "append-inner-icon": "$euro",
                                                                    "hide-details": ""
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, null, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_text_field_filled, {
                                                                    modelValue: doc.grossAmount,
                                                                    "onUpdate:modelValue": ($event: any) => ((doc.grossAmount) = $event),
                                                                    label: "TTC",
                                                                    outlined: "",
                                                                    readonly: "",
                                                                    dense: "",
                                                                    "append-inner-icon": "$euro",
                                                                    "hide-details": ""
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                cols: "1",
                                                                class: "d-flex align-center justify-center"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  (
                                                                        _ctx.expenseReport.status !==
                                                                        'VALIDATED'
                                                                    )
                                                                    ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                                        key: 0,
                                                                        onClick: ($event: any) => (_ctx.deleteDocument(doc.id)),
                                                                        size: "small"
                                                                      }, null, 8, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["modelValue"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        (_ctx.showDetail)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: "12"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "py-2 align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { class: "v-col-auto pr-3" }, {
                                                      default: _withCtx(() => _cache[50] || (_cache[50] = [
                                                        _createTextVNode(" Détails ")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_divider)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.showDetail)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 1,
                                              cols: "12",
                                              class: "py-2 mb-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_accounting_item_static, {
                                                  companyId: _ctx.companyId,
                                                  expenseReportId: _ctx.id,
                                                  onUpdate: _ctx.refresh,
                                                  mode: "Payment"
                                                }, null, 8, ["companyId", "expenseReportId", "onUpdate"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode(_component_v_card_actions, { class: "d-flex justify-end" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_v_btn_prev, {
                                          disabled: _ctx.prevDisabled,
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.prev()))
                                        }, null, 8, ["disabled"]),
                                        _createVNode(_component_v_btn_next, {
                                          disabled: _ctx.nextDisabled,
                                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.next()))
                                        }, null, 8, ["disabled"])
                                      ]),
                                      (
                                            _ctx.expenseReport.status === 'EDITION' ||
                                            _ctx.expenseReport.status === 'INFORMATION_REQUEST'
                                        )
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            color: "primary",
                                            class: "mx-1",
                                            onClick: _cache[14] || (_cache[14] = ($event: any) => ((_ctx.save(), _ctx.valideDestination()))),
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[51] || (_cache[51] = [
                                              _createTextVNode(" Enregistrer ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_btn, {
                                        color: "primary",
                                        class: "mx-1",
                                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submit())),
                                        disabled: _ctx.disabledSubmit,
                                        id: "ValidNoteDeFrais",
                                        "data-cy": "ExpenseReport2-valid",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.submitTitle), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { key: "1" }, {
                default: _withCtx(() => [
                  (_ctx.selectedDocumentId && _ctx.step === 1)
                    ? (_openBlock(), _createBlock(_component_DocumentRouterInExpenseReport, {
                        key: 0,
                        mode: 'ExpenseReport',
                        companyId: _ctx.companyId,
                        id: _ctx.selectedDocumentId,
                        "dark-mode": false,
                        onBack: _cache[16] || (_cache[16] = ($event: any) => (_ctx.step = 0))
                      }, null, 8, ["companyId", "id"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "pb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  class: "px-1 d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      rounded: "",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => {
                            _ctx.activeUploadDocuments = true;
                            _ctx.activeTravelExpense = false;
                        }),
                      class: "btn",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                        _createTextVNode("Nouvelles factures")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  class: "px-1 d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "btn",
                      rounded: "",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => {
                            _ctx.activeUploadDocuments = false;
                            _ctx.activeTravelExpense = true;
                            _ctx.currentTravelExpenseDocument = null;
                        }),
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[53] || (_cache[53] = [
                        _createTextVNode("Frais kilométriques")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "py-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      outlined: "",
                      modelValue: _ctx.expenseReport.name,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.expenseReport.name) = $event)),
                      label: "Nom de la note de frais",
                      "hide-details": "",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "pb-1 pt-0" }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "pb-2 pt-3 pl-0",
              style: {"max-height":"calc(100vh - 258px)","overflow-y":"auto"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expenseReport.documents, (item, index) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    cols: "12",
                    class: "pb-2",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        elevation: "0",
                        style: {"border-radius":"8px"},
                        onClick: _withModifiers(($event: any) => (_ctx.openDocument(item)), ["stop"]),
                        loading: item.status === 'ORIGINAL_UPLOADED' || item.status === 'UPLOADED'
                      }, {
                        loader: _withCtx(({ isActive }) => [
                          isActive
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_v_progress_linear, { indeterminate: "" }),
                                _cache[54] || (_cache[54] = _createElementVNode("span", { class: "px-2 pt-1" }, "En cours d'analyse ...", -1))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "pt-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "10",
                                  style: {"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getCategoryText(item.accountableAccount)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, {
                                  cols: "2",
                                  class: "d-flex justify-end"
                                }, {
                                  default: _withCtx(() => [
                                    (
                                            item.status === 'ORIGINAL_UPLOADED' ||
                                            item.status === 'UPLOADED'
                                        )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                          (item.signedUrl)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 0,
                                                color: "secondary"
                                              }, {
                                                default: _withCtx(() => _cache[55] || (_cache[55] = [
                                                  _createTextVNode("$oss-file")
                                                ])),
                                                _: 1
                                              }))
                                            : (item.travelExpense)
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 1,
                                                  color: "secondary"
                                                }, {
                                                  default: _withCtx(() => _cache[56] || (_cache[56] = [
                                                    _createTextVNode("$oss-car")
                                                  ])),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                        ]))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            (
                                    !(
                                        item.status === 'ORIGINAL_UPLOADED' ||
                                        item.status === 'UPLOADED'
                                    )
                                )
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 0,
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      style: {"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"},
                                      class: "flex-grow-0 flex-shrink-1",
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        (item.date)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              color: "secondary",
                                              size: "small",
                                              location: "start"
                                            }, {
                                              default: _withCtx(() => _cache[57] || (_cache[57] = [
                                                _createTextVNode("$oss-calendar")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(_toDisplayString(_ctx.getDateFormated(item.date)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "d-flex align-center justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.netAmount
                                            ? _ctx.newCommonFormatCurrency(item.netAmount, undefined)
                                            : "-"), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick", "loading"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_ctx.displayHereMap)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      class: "justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_HereMap, {
                          origin: _ctx.hereMapData.origin,
                          destination: _ctx.hereMapData.destination,
                          vehiculeType: _ctx.hereMapData.vehiculeType
                        }, null, 8, ["origin", "destination", "vehiculeType"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex align-self-end"
            }, {
              default: _withCtx(() => [
                (_ctx.commonEnableModification)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      class: "d-flex justify-center px-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_primary, {
                          block: "",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.submit())),
                          disabled: _ctx.disabledSubmit,
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.submitTitle), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.createBottomToolbar())
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "4",
                      xs4: "",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "btn",
                          size: "small",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setOpenChat('DENIED'))),
                          icon: "$clear"
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.createBottomToolbar())
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 2,
                      cols: "4",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.setOpenChat('INFORMATION_REQUEST'))),
                          icon: "$fa-comments"
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.createBottomToolbar())
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 3,
                      cols: "4",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.valid())),
                          icon: "$check"
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.accountableAccountDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 0,
                  modelValue: _ctx.accountableAccountDialog,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.accountableAccountDialog) = $event)),
                  title: "Type de facture",
                  class: "px-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "px-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select_filled, {
                              modelValue: _ctx.selectedDocument['accountableAccount']['name'],
                              "onUpdate:modelValue": [
                                _cache[25] || (_cache[25] = ($event: any) => ((_ctx.selectedDocument['accountableAccount']['name']) = $event)),
                                _cache[26] || (_cache[26] = ($event: any) => (_ctx.categoryChangeMobile()))
                              ],
                              items: _ctx.categories,
                              "hide-details": "",
                              density: "compact",
                              "item-title": "text"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          style: {"max-height":"85vh","overflow-y":"auto"},
                          class: "py-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DocumentRouterInExpenseReport, {
                              mode: 'GeneralLedger',
                              companyId: _ctx.companyId,
                              id: _ctx.selectedDocument.id,
                              "dark-mode": true
                            }, null, 8, ["companyId", "id"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.activeTravelExpense,
        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.activeTravelExpense) = $event)),
        title: "Frais kilométriques",
        "max-width": "60vw",
        "min-width": "50vw"
      }, {
        actions: _withCtx(() => [
          (!_ctx.currentTravelExpenseDocument)
            ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                key: 0,
                block: "",
                disabled: 
                        !_ctx.expenseReport.name ||
                        !_ctx.commonEnableModification ||
                        !_ctx.currentTravelExpenseAmount
                    ,
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.newTravelExpense())),
                size: "large"
              }, {
                default: _withCtx(() => _cache[58] || (_cache[58] = [
                  _createTextVNode("Ajouter")
                ])),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (_ctx.currentTravelExpenseDocument)
            ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                key: 1,
                block: "",
                onClick: _cache[31] || (_cache[31] = ($event: any) => ((_ctx.modifyTravelExpense(), _ctx.valideDestination()))),
                size: "large"
              }, {
                default: _withCtx(() => _cache[59] || (_cache[59] = [
                  _createTextVNode("Modifier")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_ExpenseReportAddress, {
            travelExpense: _ctx.currentTravelExpense,
            isOwner: _ctx.currentUser.id === _ctx.creator.id,
            expenseStatus: _ctx.expenseReport.status,
            year: _ctx.year,
            onOrigin: _cache[28] || (_cache[28] = ($event: any) => (_ctx.setOrigin($event))),
            onDestination: _cache[29] || (_cache[29] = ($event: any) => (_ctx.setDestination($event)))
          }, null, 8, ["travelExpense", "isOwner", "expenseStatus", "year"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.userDialog,
        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.userDialog) = $event)),
        title: 'Collaborateur',
        "max-width": "800px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_select_user, {
            class: "px-1",
            modelValue: _ctx.expenseReport.user,
            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.expenseReport.user) = $event)),
            companyId: _ctx.companyId,
            type: 'NATURAL_PERSON',
            onUserSelected: _cache[34] || (_cache[34] = ($event: any) => (_ctx.userDialog = false))
          }, null, 8, ["modelValue", "companyId"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.deleteDialog,
        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.deleteDialog) = $event)),
        title: "Supprimer cette note de frais ?",
        validTitle: "Supprimer",
        error: true,
        onValid: _ctx.deleteExpenseReport,
        prefixDataCy: "ExpenseReport2-deleteValid",
        width: "60vw"
      }, {
        default: _withCtx(() => _cache[60] || (_cache[60] = [
          _createTextVNode(" Etes-vous sur de vouloir supprimer cette note de frais ? ")
        ])),
        _: 1
      }, 8, ["modelValue", "onValid"]),
      _createVNode(_component_DocumentWizardDialog, {
        modelValue: _ctx.activeUploadDocuments,
        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.activeUploadDocuments) = $event)),
        showFirstPrevious: false,
        companyId: _ctx.companyId,
        documentType: 'EXPENSE_REPORT_DOCUMENT',
        ownerId: _ctx.expenseReportUserId,
        onNewDocument: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onNewDocument($event))),
        onFilesUploaded: _cache[39] || (_cache[39] = ($event: any) => (_ctx.filesUploaded()))
      }, null, 8, ["modelValue", "companyId", "ownerId"])
    ]),
    _: 1
  }, 8, ["style"]))
}